import { AddressModel, ChannelRoles, GroupInfo } from "generated/CoreApi_v1";

export type AutoCompleteDataModel = {
    key: any;
    label: string;
    thumbnailUrl?: string | null;
    canDelete?: boolean | null;
    selectable?: boolean | null;
    fixed?: boolean | null;
    fromHistory?: boolean;
};

export type UnitAutoCompleteDataModel = AutoCompleteDataModel & {
    unitTypeId: string;
    unitTypeName: string;
    includeDescendants: boolean;
    usersGroup: GroupInfo;
    allUsersGroup: GroupInfo;
};

export type TopicAutoCompleteDataModel = AutoCompleteDataModel & {
    requiredGroup: GroupInfo;
    optionalGroup: GroupInfo;
    sysQuestionGroupId?: string | null;
};

export type ChannelAutoCompleteDataModel = AutoCompleteDataModel & {
    usersGroup: GroupInfo;
    isPrivate: boolean;
};

export type ModeratorChannelAutoCompleteDataModel = AutoCompleteDataModel & {
    role: ChannelRoles;
};

export type ManagerAutoCompleteDataModel = AutoCompleteDataModel & {
    allSubordinatesGroup: GroupInfo;
    directSubordinatesGroup: GroupInfo;
};

export type AgreementAutoCompleteDataModel = AutoCompleteDataModel & {
    text: string | null;
};

export type TrainingAutoCompleteDataModel = AutoCompleteDataModel & {
    approvedUsersGroup: GroupInfo;
    enrolledUsersGroup: GroupInfo;
    attendingUsersGroup: GroupInfo;
};

export type MeetingRoomAutoCompleteDataModel = AutoCompleteDataModel & {
    address: AddressModel;
};

export type AutoCompleteSuggestions<T> = {
    items: T[];
    totalRows: number;
};

export function createAutoCompleteModel(key: any, label: string, thumbnailUrl?: string, canDelete?: boolean, selectable?: boolean, fixed?: boolean, fromHistory?: boolean): AutoCompleteDataModel {
    return {
        key,
        label,
        thumbnailUrl: thumbnailUrl,
        canDelete: canDelete ?? true,
        selectable: selectable ?? true,
        fixed: fixed ?? false,
        fromHistory: fromHistory ?? false
    };
}
